module.exports = __webpack_public_path__ + "static/media/teletava.74aa6936.png";